// frontend/admin-portal/src/components/users/RoleModal.jsx
import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Input,
  Alert,
  PermissionTree,
  Checkbox,
} from "@fiberhome/shared-ui";
import { roleService } from "../../services/roleService";

export default function RoleModal({ open, role, onClose, onSaved }) {
  const [form, setForm] = useState({
    name: "",
    displayName: "",
    description: "",
    permissions: [],
    isActive: true,
  });
  const [catalog, setCatalog] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    roleService
      .catalog()
      .then(({ catalog }) => setCatalog(catalog))
      .catch(() => setCatalog([]));
    if (role) {
      setForm({
        name: role.name,
        displayName: role.displayName,
        description: role.description || "",
        permissions: role.permissions || [],
        isActive: role.isActive !== false,
      });
    } else {
      setForm({
        name: "",
        displayName: "",
        description: "",
        permissions: [],
        isActive: true,
      });
    }
  }, [open, role]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    setSaving(true);
    setError("");
    try {
      if (role?.id) await roleService.update(role.id, form);
      else await roleService.create(form);
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={role ? `Edit Role: ${role.displayName}` : "New Role"}
      size="xl"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} loading={saving}>
            {role ? "Save Role" : "Create Role"}
          </Button>
        </>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <div className="row g-3 mb-3">
        <div className="col-md-6">
          <Input
            label="Display Name *"
            value={form.displayName}
            onChange={(e) => set("displayName", e.target.value)}
            hint="Shown in the UI — e.g. 'Warehouse Supervisor'"
          />
        </div>
        <div className="col-md-6">
          <Input
            label="Internal Name *"
            value={form.name}
            onChange={(e) => set("name", e.target.value)}
            disabled={role?.isSystem}
            hint="Lowercase slug used internally — e.g. 'warehouse-sup'"
          />
        </div>
        <div className="col-12">
          <Input
            label="Description"
            value={form.description}
            onChange={(e) => set("description", e.target.value)}
          />
        </div>
        <div className="col-12">
          <Checkbox
            checked={form.isActive}
            onChange={(v) => set("isActive", v)}
            label="Role is active"
          />
        </div>
      </div>

      <div className="fh-modal-section-title">Permissions</div>
      <PermissionTree
        catalog={catalog}
        selected={form.permissions}
        onChange={(next) => set("permissions", next)}
      />
    </Modal>
  );
}
